import { Button, Grid, Box } from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import { UserResponseDTO, SubGroupsClient } from '../generated/ApiClient'
import MUIDataTable from "mui-datatables";
import { Link as RouterLink, RouteComponentProps } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { actionCreators as snackbar } from '../store/AlertSnackbarStore'
import { UserFriendlyRoleNames } from '../hooks/useIsUserInRoles';
import { tableOptions as options } from '../common/Shared';
import { Admin, useIsUserInRoles } from '../hooks/useIsUserInRoles';

interface UsersTableData {
    userName: string;
    firstName: string;
    lastName: string;
    role: string;
    azureId: string;
}

type props = {
    subgroupId: string | undefined;
    organizationId: string | undefined;
}

export default function SubgroupUsers(props: props) {
    const [usersData, setUsersData] = useState<UsersTableData[]>([]);
    const subgroupId = props.subgroupId
    const organizationId = props.organizationId

    const dispatch = useDispatch()
    const isAdmin = useIsUserInRoles(Admin)

    const removeUsers = async (userIds: string[]) => {
        try {
            if (subgroupId) {
                await Promise.all(userIds.map((userId) => removeUser(userId, subgroupId)));
                dispatch(snackbar.addMessage({ title: "Success", message: `Users successfully removed`, alertType: 'success' }))
                const newUsersData = usersData.filter(x => !userIds.includes(x.azureId));
                setUsersData(newUsersData)
            }
        }
        catch (error) {
            dispatch(snackbar.addError(error, undefined, 'Error writing to the database'));
        }
    }

    const removeUser = async (userId: string, subgroupId: string) => {
        try {
            await new SubGroupsClient().removeUser(subgroupId, userId);
        }
        catch (error) {
            dispatch(snackbar.addError(error, undefined, 'Error writing to the database'));
        }
    }

    const tableOptions = {
        ...options,
        selectableRowsHideCheckboxes: !isAdmin,
        onRowsDelete: ((rowsDeleted: { lookup: any; data: { index: number; dataIndex: number; }[]; }, data: UsersTableData[]) => {
            const selectedIndexs = rowsDeleted.data.map((row) => row.dataIndex);
            const userIds: string[] = selectedIndexs.map((index) => usersData![index].azureId);
            removeUsers(userIds);
        })
    }

    const columns = [
        {
            name: "userName",
            label: "Email",
            options: {
                sort: true,
                filter: true
            }
        },
        {
            name: "firstName",
            label: "First Name",
            options: {
                sort: true,
                filter: true
            }
        },
        {
            name: "lastName",
            label: "Last Name",
            options: {
                sort: true,
                filter: true
            }
        },
        {
            name: "role",
            label: "Role",
            options: {
                sort: true,
                filter: true
            }
        },
        {
            name: 'detailsButton',
            label: 'View',
            options: {
                sort: false,
                filter: false,
                customBodyRenderLite: (dataIndex: number) => {
                    const link = `/users/${usersData[dataIndex].azureId}`;
                    return <Button component={RouterLink} variant='contained' size='small' to={link}>View</Button>
                }
            }
        }
    ];

    function toTableData(userData: UserResponseDTO) {
        return {
            userName: userData.userName,
            firstName: userData.givenName,
            lastName: userData.surname,
            role: UserFriendlyRoleNames[userData.role.Case],
            azureId: userData.azureId
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            if (subgroupId) {
                const usersData = await new SubGroupsClient().getManyUsers(subgroupId);
                setUsersData(usersData.map(toTableData));
            }
        }
        fetchData();
    }, [subgroupId, organizationId])

    return (
        <>
            {isAdmin &&
                <Grid container item direction='column' spacing={2} alignItems='flex-end'>
                    <Box my={2}>
                        <Button component={RouterLink} variant='contained' color='primary' size='medium' to={`/organizations/${organizationId}/subgroups/${subgroupId}/addMember`}>+ Add</Button>
                    </Box>
                </Grid>}
            <MUIDataTable
                title={""}
                data={usersData}
                columns={columns}
                options={tableOptions}
            />
        </>
    )
}